import { validateRequest } from "../state";
import { makeToCheckoutProps } from "./makeToCheckoutProps";
import { store } from "../../../applicationState";

export const toCheckoutProps = makeToCheckoutProps(store.dispatch, validateRequest);
